import { executeRequest, Request } from '@jfs/network'
import { mimeTypes } from '../utils/constants'
import { APIEndPoints } from './APIEndPoints'
import { getUrl, sitConfig } from './config'

const responseParser = (response: any, type: string) => {
  downloadFile(
    response,
    response?.fileName ?? type === 'bulkConfig'
      ? 'BulkConfig_File'
      : type === 'bulkUpload'
      ? 'BulkOnboarding_File'
      : type === 'bulkCard'
      ? 'BulkCardConfig_File'
      : type === 'bulkVpa'
      ? 'BulkVpas_File'
      : type === 'bulkStore'
      ? 'BulkStore_File'
      : type === 'bulkTerminal'
      ? 'BulkTerminal_File'
      : type === 'MCC_EXPORT'
      ? 'BULK_MCC_OPS'
      : type === 'IFSC_EXPORT'
      ? 'BULK_IFSC_OPS'
      : type === 'PINCODE_EXPORT'
      ? 'BULK_PINCODE_OPS'
      : type === 'PROGRAM_CATEGORY_EXPORT'
      ? 'BULK_PROGRAM_CATEGORY_OPS'
      : type === 'BULK_STORE_UPDATE'
      ? 'BULK_STORE_UPDATE'
      : type === 'BULK_DEVICES'
      ? 'BULK_DEVICES'
      : type === 'BULK_TERMINAL_UPDATE'
      ? 'BULK_TERMINAL_UPDATE'
      : 'BulkSync_File',
  )
  return response
}

const downloadFile = (resp: any, fileName: string) => {
  let contentType = resp.headers['content-type']
  if (mimeTypes.get(contentType) === undefined) {
    return
  } else {
    const blob = new Blob([resp?.data], { type: contentType })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    document.body.appendChild(a)
    a.href = url
    a.download = `${fileName}${mimeTypes.get(contentType)}`
    a.click()
    window.URL.revokeObjectURL(url)
    document.body.removeChild(a)
  }
}

const typeMap = {
  bulkConfig: 'BULK_CONFIG',
  bulkUpload: 'CREATE',
  bulkCard: 'BULK_CARD_CONFIG',
  bulkVpa: 'BULK_VPA',
  bulkStore: 'BULK_STORE',
  bulkTerminal: 'BULK_TERMINAL',
  MCC_EXPORT: 'BULK_MCC_OPS',
  IFSC_EXPORT: 'BULK_IFSC_OPS',
  PINCODE_EXPORT: 'BULK_PINCODE_OPS',
  PROGRAM_CATEGORY_EXPORT: 'BULK_PROGRAM_CATEGORY_OPS',
  BULK_STORE_UPDATE: 'BULK_STORE_UPDATE',
  BULK_DEVICES: 'BULK_DEVICES',
  BULK_TERMINAL_UPDATE: 'BULK_TERMINAL_UPDATE',
  ADD_MERCHANT_MAPPING: 'BULK_PAYMENT_CONFIG',
  BULK_KEY_EXCHANGE_UPLOAD: 'BULK_KEY_EXCHANGE_UPLOAD',
  APPROVE_MERCHANT_MAPPING: 'BULK_PMT_CONFIG_REVIEW',
  BATCH_MAKER: 'BULK_BATCH_CLOSURE',
  BATCH_CHECKER: 'BULK_BATCH_CLOSURE_REVIEW',
  BULK_USER_MANAGEMENT: 'BULK_USER_MANAGEMENT',
  CHECKER_1_BULK_CLAIM: 'BULK_CHECKER_ONE_CLAIM',
  CHECKER_2_BULK_CLAIM: 'BULK_CHECKER_TWO_CLAIM',
  CHECKER_1_BULK_ACTION: 'BULK_CHECKER_ONE_APPROVE',
  CHECKER_2_BULK_ACTION: 'BULK_CHECKER_TWO_APPROVE',
}

export const getType = (type) => typeMap[type] || 'SYNC'

const bulkOnboardingFileDownload = (fileId: number, type: string, tokens: any) => {
  const request: Request<{}> = {
    apiPath: getUrl(APIEndPoints.bulkOnboardFileDownload),
    method: 'POST',
    config: sitConfig(tokens),
    body: {
      fileId: fileId,
      type: getType(type),
    },
    responseType: 'arraybuffer',
  }

  return executeRequest(request)
    .then((resp) => responseParser(resp, type))
    .catch((error) => {
      throw error
    })
}

export { bulkOnboardingFileDownload }
